export default __webpack_public_path__ + "static/media/button-red-down-129x58.598093f7.svg";